module.exports = __webpack_public_path__ + "send-twitter.95d5f4ac.jpg";